import { Typography } from '@mui/material';
import theme from 'library/theme/theme';
import styled from 'styled-components';

export const InfoText = styled(Typography)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(2)};
`;
